import React from 'react';
import Router from './Router';
import './App.css';
import Snowfall from "react-snowfall";
import GlobalModule from './components/Modules/GlobalModule';

const App = () => {
  return (
    <GlobalModule>
      <Router />
      <Snowfall
        snowflakeCount={200}
        style={{ position: "fixed", inset: 0, zIndex: 9999, pointerEvents: "none" }}
      />
    </GlobalModule>
  )
}

export default App